import { Validator } from '@vista-digital/validator';
/**
 * Render options for the Google reCAPTCHA v2:
 * - 'compact' and 'normal' change the size of the rendered checkbox reCAPTCHA
 * - 'invisible' does not render any element and needs to be triggered programmatically
 */
export var RecaptchaV2Size;
(function (RecaptchaV2Size) {
    RecaptchaV2Size["Compact"] = "compact";
    RecaptchaV2Size["Normal"] = "normal";
    RecaptchaV2Size["Invisible"] = "invisible";
})(RecaptchaV2Size || (RecaptchaV2Size = {}));
export const recaptchaV2SizeValidator = Validator.oneOf(Object.values(RecaptchaV2Size));
